<cc-edit-modal (close)="onClose()">
  <ng-container slot="toolbar">
    <button
      type="button"
      class="btn btn-light icon"
      ngbPopover="Delete"
      popoverClass="popover-dark"
      triggers="mouseenter:mouseleave"
      placement="bottom"
      (click)="onDelete()"
    >
      <i class="cc-icon cc-icon-delete sm-text-default-red"> </i>
    </button>
  </ng-container>

  <ng-container slot="body">
    <cc-edit-modal-page class="large" *ngIf="isChartSetup; else empty">
      <div class="sm-flex sm-space-x-6">
        <section><img class="company-logo" [src]="company.logo" alt="company logo" /></section>
        <section class="dashboard-header-filepath">
          <p class="sm-text-left sm-line-clamp-3">
            <strong i18n>Filepath: </strong><span>{{ filepath }}</span>
          </p>
        </section>
        <section class="dashboard-header-metadata">
          <p class="sm-max-w-full sm-overflow-hidden sm-text-ellipsis sm-whitespace-nowrap" *ngIf="dashboard">
            <strong i18n>Dashboard: </strong> <span>{{ dashboard.name || '-' }}</span>
          </p>
          <p class="sm-line-clamp-2" *ngIf="chart?.template">
            <strong i18n>Source: </strong> <span>{{ chart.template.name || '-' }}</span>
          </p>
        </section>
      </div>
      <hr class="title-color-line" [style.background-color]="company?.colorCode" />
      <div class="row mb-3 chart-info" *ngIf="chart">
        <div class="col">
          <div class="edit-chart-name" *ngIf="editNameVisible">
            <input type="text" class="form-control" #editName [(ngModel)]="chart.name" (blur)="saveName()" />
          </div>
          <div class="font-weight-bold" *ngIf="!editNameVisible" (click)="showEditName()">
            <span class="chart-name">
              <span>{{ displayedChartName || 'Untitled Chart' }}</span> <i class="cc-icon cc-icon-pencil"></i>
            </span>
          </div>
          <div class="text-capitalize secondary-text mt-2" i18n>
            {{ chart.kind }}
          </div>
        </div>
        <div class="col text-right secondary-text" *ngIf="!editNameVisible">
          <div>
            <span i18n>Data on this chart is organised by:</span>
            {{ getTemplateSortingFieldName(chart.template) }}
          </div>
          <div class="mt-1">
            <a [href]="learnMoreLinks[chart.kind]" target="_blank" class="btn cc-btn-subtle-gray btn-sm">
              <i class="cc-icon cc-icon-question"></i> <span i18n>Learn more</span>
            </a>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col chart-container" [class.chart-pie]="chart?.kind === chartTypes.Ratio">
          <ng-container *ngIf="chart; else loadingChart">
            <ng-container *ngIf="chart.template; else noTemplate">
              <ng-container [ngSwitch]="chart.kind">
                <cc-quantity-chart
                  *ngSwitchCase="chartTypes.Quantity"
                  [chart]="chart"
                  [forms]="forms"
                  [dateRange]="dataDateRange"
                  [loading]="loading"
                ></cc-quantity-chart>

                <cc-frequency-chart
                  *ngSwitchCase="chartTypes.Frequency"
                  [chart]="chart"
                  [forms]="forms"
                  [dateRange]="dataDateRange"
                  [loading]="loading"
                ></cc-frequency-chart>

                <cc-ratio-chart
                  *ngSwitchCase="chartTypes.Ratio"
                  [chart]="chart"
                  [forms]="forms"
                  [dateRange]="dataDateRange"
                  [loading]="loading"
                  class="w-100 h-100"
                >
                </cc-ratio-chart>
              </ng-container>
            </ng-container>
          </ng-container>

          <ng-template #noTemplate>
            <div class="chart-placeholder">
              <div class="text-center" i18n>No data to display</div>
            </div>
          </ng-template>
        </div>
      </div>
    </cc-edit-modal-page>

    <cc-edit-modal-page class="large" *ngIf="chart">
      <ng-container [ngSwitch]="chart.kind">
        <cc-quantity-chart-settings
          [chart]="chart"
          [teamId]="teamId"
          [templates]="templates"
          [dataDateRange]="dataDateRange"
          (onChange)="onSettingsChange($event)"
          *ngSwitchCase="chartTypes.Quantity"
        ></cc-quantity-chart-settings>

        <cc-frequency-chart-settings
          [chart]="chart"
          [teamId]="teamId"
          [templates]="templates"
          [dataDateRange]="dataDateRange"
          (onChange)="onSettingsChange($event)"
          *ngSwitchCase="chartTypes.Frequency"
        ></cc-frequency-chart-settings>

        <cc-ratio-chart-settings
          [chart]="chart"
          [teamId]="teamId"
          [templates]="templates"
          [dataDateRange]="dataDateRange"
          (onChange)="onSettingsChange($event)"
          *ngSwitchCase="chartTypes.Ratio"
        >
        </cc-ratio-chart-settings>
      </ng-container>
    </cc-edit-modal-page>

    <cc-edit-modal-page class="large" *ngIf="isChartSetup && chart.template">
      <cc-chart-view-modal-filters
        [chart]="chart"
        (onChange)="onFilterChange($event)"
      ></cc-chart-view-modal-filters>
    </cc-edit-modal-page>
  </ng-container>
</cc-edit-modal>

<ng-template #empty>
  <div *ngIf="!loading; else loadingChart" class="secondary-text text-center mt-3" i18n>
    Your chart will populate once the source settings are specified below
  </div>
</ng-template>

<ng-template #loadingChart>
  <div class="chart-placeholder loading-spinner">
    <div class="cc-icon cc-icon-spinner-3x"></div>
  </div>
</ng-template>
